import { ActionTypes } from "./constants";

const initialState = {
  userProfileData: [],
  useProfileEditData: {},
  saveUserData: null,
  saveUnRegisterUserData: false,
  isRegisterUser: false,
  selectedObj: null,
  userIdProfileSettingData: [],
  isSettingPageShow: false,
  userSupplierDetails: {},
  gridActions: {
    sorting: {
      columnId: -1,
      columnOrder: "",
    },
  },
  isAuthenticated: null,
  isAccessRequestSent: false,
};

export const userProfileReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.USER_PROFILE_USER_FETCH_DATA_SUCCESS:
      return {
        ...state,
        userProfileData: action.payload.data || [],
      };
    case ActionTypes.USER_PROFILE_SAVE_USER_DATA_SUCCESS:
      return {
        ...state,
        saveUserData: action.payload.data || [],
      };
    case ActionTypes.USER_PROFILE_USER_ID_FETCH_DATA_SUCCESS:
      return {
        ...state,
        useProfileEditData: action.payload.data || {},
      };
    case ActionTypes.UNREGISTER_USER_SAVE_DATA_SUCCESS:
      return {
        ...state,
        saveUnRegisterUserData: action.payload.data || [],
      };
    case ActionTypes.REGISTER_USER_SAVE_ROLE_DATA:
      return {
        ...state,
        saveRegisterUserRoleData: action.payload.userRoleData || [],
      };
    case ActionTypes.REGISTER_USER_SAVE_SELECTED_ROLE_DATA:
      return {
        ...state,
        selectedObj: action.payload.selectedObj || [],
      };
    case ActionTypes.USER_PROFILE_SETTING_USER_ID_DATA_SUCESS:
      return {
        ...state,
        userIdProfileSettingData: action.payload.data || [],
      };
    case ActionTypes.USER_PROFILE_SETTING_PAGE_SHOW:
      return {
        ...state,
        isSettingPageShow: action.payload,
      };
    case ActionTypes.USER_PROFILE_SUPPLIER_DETAILS:
      return {
        ...state,
        userSupplierDetails: action.payload.data,
      };
    case ActionTypes.USER_PROFILE_GRID_ACTIONS:
      return {
        ...state,
        gridActions: action.payload.data,
      };
    case ActionTypes.FETCH_IS_AUTHETICATED_SUCCESS:
      return {
        ...state,
        isAuthenticated: action.payload.data,
      };

    case ActionTypes.RESET_IS_AUTHETICATED:
      return {
        ...state,
        isAuthenticated: null,
      };

    case ActionTypes.USER_PROFILE_ACCESS_REQUEST_SENT_SUCCESS:
      return {
        ...state,
        isAccessRequestSent: action.payload,
      };
    default:
      return state;
  }
};
